import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ProductionOrder } from '../model/ProductionOrder';
import { GLOBAL } from './global';
import { FilterUrlService } from './filter-url.service';
import 'rxjs/add/operator/map';
import * as moment from 'moment';

@Injectable()
export class ProductionOrderService {
  //url:string = GLOBAL.url+"production_orders?sort=-id";
  url:string = GLOBAL.url+"production_orders";
  filter:string;

  constructor( private http:HttpClient, private _urlService:FilterUrlService ) {
    this._urlService.filters.subscribe(new_filter => this.filter = new_filter );
  }

  /**
  * Obtiene el listado de 10 elementos.
  * @return listado de orden de produccion
  */
  public get(){
    let url = this.url+this.filter;
    return this.http.get(url)
    .map( res => {
      return res;
    });
  }

  public getDataFiltered(filters){
    let url = this.url+filters;
    return this.http.get(url).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el numero de orden mas alto.
  * @return el numero mas alto.
  */
  public getLastOP(){
    let url = GLOBAL.url+'production_orders?sort=-number&limit=1';
    return this.http.get(url).map( res => {
      return res;
    });
  }

  public getOne(id){
    let url = GLOBAL.url+'production_orders?id='+id;
    return this.http.get(url).map( res => {
      return res;
    });
  }

  public getOneNumber(id){
    let url = GLOBAL.url+'production_orders?number='+id;
    return this.http.get(url).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los elementos.
  * @return listado o un error.
  */
  public getAll(){
    let url = this.url+'?sort=+number&limit=300';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado simplificado de todas las op.
  * @return listado o un error.
  */
  public getAllSimple(){
    let url = this.url+'?simple&sort=+number&limit=300';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado simplificado de todas las op con status_id = 1 (activa).
  * @return listado o un error.
  */
  public getAllSimple2(){
    let url = this.url+'?simple2&sort=+number&limit=300&status_id=1';
    return this.http.get(url ).map( res => {
      return res;
    });
  }


  /**
  * Obtiene el listado de todos los elementos, hasta los elementos borrados por sistema.
  * @return listado o un error.
  */
  public getAll2(){
    let url = this.url+'?soft&limit=1000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getAllUndone(){
    let url = this.url+'?sort=+number&status_id=1&limit=1000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getAllUndoneSimple(){
    let url = this.url+'?simple&sort=+number&status_id=1&limit=1000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getAllStockFromOP(id){
    let url = GLOBAL.url+'production_orders/'+id+'/tags?limit=10000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene un PDF.
  * @return url de pdf.
  */
  public getPDF(id:string){
    return GLOBAL.url+'production_orders/'+id+'/packing_list';
  }

  /**
  * Obtiene un PDF.
  * @return url de pdf.
  */
  public getPDFDetails(id:string){
    return GLOBAL.url+'production_orders/'+id+'/pdf';
  }

  public getPackingListFromOP(id){
    let url = GLOBAL.url+'production_orders/'+id+'/packing_list_data?limit=1000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getProductsFromOP(id){
    let url = GLOBAL.url+'production_orders/'+id+'/products?limit=1000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public getAllStatusFromOP(){
    let url = GLOBAL.url+'po_status';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  public save(prov:any){

    return this.http.post(this.url, prov)
    .map( data => {
      return data;
    });
  }

  public update(url:string, body){

    return this.http.put(url, body)
    .map( data => {
      return data;
    });
  }

  public updateCerrarOP(body,id){
   let url = GLOBAL.url+`production_orders/${id}`;
    return this.http.put(url, body)
    .map( data => {
      return data;
    });
  }

  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });

  }

  transformDates(fechas:Date):String{
    let fecha = moment(fechas);
    //2018-02-28 00:00:00
    return (fecha.year()+'-'+(fecha.month()+1)+'-'+fecha.date()+' 00:00:00');
  }

  addDatesYears(dt:any){
    let fecha = moment(dt);

    fecha = fecha.add(2,'y');

    return (new Date(fecha.year(), fecha.month(), fecha.date(),0,0,0,0));
  }

  yearMonthDayFormat(dt:any){
    let fecha = moment (dt);
    return  fecha.date()+'/'+fecha.month()+'/'+fecha.year();
  }

  transformData(data:any){
    let p = new ProductionOrder(
      data['id'],
      data['ordendeproduccion'],
      data['ordendecompra'],
      this.transformDates(data['fechaordendecompra']),
      data['cliente'],
      data['pais'],
      data['contacto'],
      data['cantidad'],
      this.transformDates(data['fechadespacho']),
      data['observaciones'],
      data['estado'],
      data['especificacion'],
      data['generica']
    );
    return p.getJson();
  }

  transformDataCerrarOP(id:number){
    let op = new ProductionOrder(0,0,0,0,0,0,0,0,0,0,0,0,0);
    return op.getJsonCerrarOP(id);
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/productionOrders.service.ts